<template>
  <tm-scrollbar
    ref="scrollElement"
    :key="currentRoute.name"
    class="h100pr"
    :class="rootScrollClassName"
    :scrollbar-id="rootScrollbarId"
    :stable="stableScrollbarGutter"
  >
    <div class="page-scroll-container h100pr">
      <slot />
    </div>
  </tm-scrollbar>
</template>

<script setup lang="ts">
import { computed, ref } from '@/composition/vue/compositionApi'
import TmScrollbar from '@/components/shared/TmScrollbar.vue'
import { rootScrollbarId, rootScrollClassName } from '@/components/shared/types'
import TmLogicError from '@/core/error/tmLogicError'
import { getRouterService } from '@/core/container/ioc'

defineProps<{
  stableScrollbarGutter?: boolean
}>()

const routerService = getRouterService()

const scrollElement = ref<InstanceType<typeof TmScrollbar> | null>(null)

const currentRoute = computed(() => routerService.getCurrentRoute())

const getScrollElement = () => {
  if (!scrollElement.value) {
    throw new TmLogicError('scrollElement.value is null')
  }
  return scrollElement.value.getScrollElement()
}

defineExpose({
  getScrollElement,
})
</script>
